import { useRouter } from 'next/router'
import { ResponsiveContext, Home, ErrorPage } from 'components'
import { MetaHead } from '../../components/MetaHead'
import {
  IEntriesProps,
  dehydrate,
  getContentfulData,
  getParamsInURL
} from '@smuchile/pkg-unimarc-hooks'
import {
  cleanPageNumber,
  cleanPageNumberParam,
  getContentFulComponents
} from '../../shared/helpers'
import { SeoInfoProps } from 'pages/static/[...staticPage]'
import { BannerHome } from '../../shared/interfaces/Home'
import { ClubUnimarcFooter } from 'components/ClubAhorro/ClubUnimarcFooter'

interface LadingProps {
  data: BannerHome
  isMobile: boolean
  footer: IEntriesProps
  footerType: string
  landingUrl?: string
  seoInfo?: SeoInfoProps
}

const Landing = ({
  data,
  isMobile,
  seoInfo,
  footer,
  footerType
}: LadingProps) => {
  const router = useRouter()
  const landingCategories = router?.query?.landing as Array<string>
  const showMinifooter = footerType?.toLowerCase() === 'minifooter'
  const paramsApp = getParamsInURL('source')

  if (!data) {
    return <ErrorPage redirect={false} />
  }

  return (
    <ResponsiveContext isMobile={isMobile}>
      <>
        <MetaHead
          canonicalPath={cleanPageNumber(router?.asPath)}
          categories={cleanPageNumberParam(landingCategories)}
          contentDescription={seoInfo?.description}
          titleName={seoInfo?.pageTitle}
          type='LANDING'
        />
        <Home
          contentTypeId='landingpagesParaLaWeb'
          customMainPadding={
            router?.asPath === '/page/membresia' && '44px 0 0 0'
          }
          data={data}
          hideMainFooter={showMinifooter}
          isMobile={isMobile}
        />
        {showMinifooter && !paramsApp && (
          <ClubUnimarcFooter
            data={footer}
            margin='32px 0 0'
          />
        )}
      </>
    </ResponsiveContext>
  )
}

export async function getServerSideProps(context) {
  let landingUrl = '/page'
  context?.params?.landing?.forEach?.((landing) => {
    landingUrl += `/${landing}`
  })

  const contentOptions = {
    options: {
      content_type: 'landingpagesParaLaWeb',
      'fields.url': landingUrl,
      'fields.idDelFormato': 1,
      limit: 1,
      include: 6
    }
  }
  const {
    response: data,
    queryClient,
    seoInfo,
    footerType
  } = await getContentFulComponents({ contentOptions })

  const footer =
    footerType?.toLowerCase() === 'minifooter'
      ? await getContentfulData({
          id_contentful: 'contentful_minifooter',
          options: {
            content_type: 'unimarcWebTopFooter',
            'fields.label[in]': 'Mini Footer (Desktop)',
            'fields.platform': 'Web Unimarc eComm'
          }
        })
      : null

  if (Object.keys(data).length === 0) {
    return {
      props: {},
      notFound: true
    }
  }

  return {
    props: {
      data,
      seoInfo,
      footer,
      footerType,
      landingUrl,
      dehydratedState: dehydrate(queryClient)
    }
  }
}

export default Landing
